<template>
    <a-card>
        <!-- <a-collapse v-model:activeKey="activeKey" accordion>
            <a-collapse-panel key="1" header="审核人信息">
                <a-descriptions v-for="(item,key) in options" :key="key" size="middle" :column="{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 3, xs: 1 }" bordered={true}>
                    <a-descriptions-item  label="审核人账号" name="auditAccount">{{item.auditAccount}}</a-descriptions-item>
                    <a-descriptions-item label="审核人名称" name="auditName">{{item.auditName}}</a-descriptions-item>
                    <a-descriptions-item label="审核人审核状态" name="auditStatus">
                        <span v-if="item.auditStatus==0">未审核</span>
                        <span v-if="item.auditStatus==1">审核通过</span>
                        <span v-if="item.auditStatus==2">审核未通过</span>
                    </a-descriptions-item>
                </a-descriptions>
            </a-collapse-panel>
        </a-collapse> -->
        <div style="position:relative;margin-top:20px">
            <a-steps class="stepsTop" :current="current">
                <a-step :class="{ changeFlex: current == 0 }" @click="current = 0; goAnchor('#current0');" title="项目基本信息" />
                <a-step :class="{ changeFlex: current == 1 }" @click="current = 1; goAnchor('#current1');" title="单位基本信息" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" :class="{ langFlex: current == 2 }"
                    @click="current = 2; goAnchor('#current2');" title="分阶段具体实施目标" />
                <a-step v-if="projectTypeShow == 2 || projectTypeShow == 3" :class="{ langFlex: current == 3 }"
                    @click="current = 3; goAnchor('#current3');" title="项目规模、指标和验收内容" />
                <a-step v-if="projectTypeShow == 3" :class="{ sortFlex: current == 4 }" @click="current = 4; goAnchor('#current4');"
                    title="预期目标" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2" :class="{ sortFlex: current == 5 }"
                    @click="current = 5; goAnchor('#current5');" title="报告正文" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 0 || projectTypeShow == 2 || projectTypeShow == 3"
                    :class="{ changeFlex: current == 6 }" @click="current = 6; goAnchor('#current6');" title="项目负责人信息" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" :class="{ changeFlex: current == 7 }"
                    @click="current = 7; goAnchor('#current7');" title="研究人员信息" />
                <a-step v-if="projectTypeShow == 2 || projectTypeShow == 3" :class="{ changeFlex: current == 8 }"
                    @click="current = 8; goAnchor('#current8');" title="合作单位信息" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" :class="{ langFlex: current == 9 }"
                    @click="current = 9; goAnchor('#current9');" title="项目经费预算情况" />
                <a-step :class="{ sortFlex: current == 10 }" @click="current = 10; goAnchor('#current10');" title="相关附件" />
            </a-steps>
                
            <div class="body-con">
                <a-divider id="current0" class="currentitem"   />
                <projectBasicsInfoMain ref="projectBasicsInfoMain"  />
                <div id="current1">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 单位基本信息 -->
                    <projectUnit ref="projectUnit" />
                </div>
                <div v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" id="current2">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 分阶段具体实施目标 -->
                    <projectImplementation ref="projectImplementation" />
                </div>
                <div v-if="projectTypeShow == 2 || projectTypeShow == 3" id="current3">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 项目规模、指标和验收内容 -->
                    <projectCheck ref="projectCheck" />
                </div>
                <div v-if="projectTypeShow == 3" id="current4">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 预期目标 -->
                    <projectExpectations ref="projectExpectations" />
                </div>
                <div v-if="projectTypeShow == 1 || projectTypeShow == 2" id="current5">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 报告正文 -->
                    <projectReporttext ref="projectReporttext" />
                </div>
                <div v-if="projectTypeShow == 1 || projectTypeShow == 0 || projectTypeShow == 2 || projectTypeShow == 3"
                    id="current6">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 项目负责人信息 -->
                    <projectLeader ref="projectLeader" />
                </div>
                <div v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" id="current7">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 研究人员信息 -->
                    <projectResearchers ref="projectResearchers" />
                </div>
                <div v-if="projectTypeShow == 2 || projectTypeShow == 3" id="current8">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 合作单位信息 -->
                    <projectCooperative ref="projectCooperative" />
                </div>
                <div v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" id="current9">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 项目经费预算情况 -->
                    <projectFundRecord ref="projectFundRecord" />
                </div>
                <div id="current10">
                    <a-divider class="currentitem" style="background-color: #bbb" dashed />
                    <!-- 相关附件 -->
                    <projectAnnex ref="projectAnnex" />
                </div>
            </div>
        </div>
    </a-card>
</template>

<script>
    import projectBasicsInfoMain from "./DtailCompnents/projectBasicsInfo";
    import projectUnit from "./DtailCompnents/projectUnit";
    import projectImplementation from "./DtailCompnents/projectImplementation";
    import projectReporttext from "./DtailCompnents/projectReporttext";
    import projectLeader from "./DtailCompnents/projectLeader";
    import projectResearchers from "./DtailCompnents/projectResearchers";
    import projectFundRecord from "./DtailCompnents/projectFundRecord";
    import projectAnnex from "./DtailCompnents/projectAnnex";
    import projectCheck from "./DtailCompnents/projectCheck";
    import projectCooperative from "./DtailCompnents/projectCooperative";
    import projectExpectations from "./DtailCompnents/projectExpectations";
        

    export default {
        name: "detailModal",
        mixins: [],
        components: {
            projectBasicsInfoMain,
            projectUnit,
            projectImplementation,
            projectReporttext,
            projectLeader,
            projectResearchers,
            projectFundRecord,
            projectAnnex,
            projectCheck,
            projectCooperative,
            projectExpectations
        },
        data() {
            return {
                projectTypeShow: null,
                permissions:0,
                current: 0,
                activeKey: [],
                options: null,
            }
        },

        mounted() {
            this.permissions = this.$route.query.permissions
            this.projectTypeShow = this.$route.query.classification
        },
        methods: {
            /*显示弹窗*/
            onShowModal(refName, data = {}) {
                const refEle = this.$refs[refName];
                refEle.form = Object.assign({}, data);
                refEle.visible = true;
            },
            backTo(){
                this.$router.push('/sys/TechnologieprojekteApply/projectBasicsInfo')
            },
            onScroll() {
                // 获取所有锚点元素
                const navContents = document.querySelectorAll('.currentitem')
                // 所有锚点元素的 offsetTop
                const offsetTopArr = []
                navContents.forEach(item => {
                    offsetTopArr.push(item.offsetTop)
                })
                
                // 获取当前文档流的 scrollTop
                var scrollTop = document.querySelector(".body-con").scrollTop+307;
                
                this.navIndex = offsetTopArr.map((item,key) => {
                    if (scrollTop >= item) {
                        return key
                    }
                })
                for (let index = 0; index < this.navIndex.length; index++) {
                    if(this.navIndex[index]==undefined){
                        this.current = index
                        return index;
                    }
                    
                }
            },
            goAnchor(selector) {/*参数selector是id选择器（#anchor14）*/
                document.querySelector(selector).scrollIntoView({
                    behavior: "smooth"
                });
            },
        }

    }
</script>
<style lang="less" scoped>
.currentitem{
    opacity: 0;
}
.changeFlex{
    flex: 2;
}
.langFlex{
    flex: 3;
}
.sortFlex{
    flex:1.3;
}

.stepsTop{
    cursor: pointer;
    width:100%;
    height: 75px;
    z-index: 999;
    padding-top: 30px;
    padding-left: 24px;
    padding-right:80px;
    background: #ffffff;
    margin-top:-20px;
    margin-left:-20px;
}
.body-con{
    overflow: auto;
    overflow-x: hidden;
    height:580px;
}
/* 定位滚动条本身 */
::-webkit-scrollbar {
    width: 5px;
  }
  
  /* 定位滚动条的轨道部分 */
  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }
  
  /* 定位滚动条的滑块部分 */
  ::-webkit-scrollbar-thumb {
    background-color: #00aeff;
    border-radius: 5px;
  }
  
  /* 定位滚动条的按钮部分 */
  ::-webkit-scrollbar-button {
    display: none;
  }
  
  /* 定位滚动条的角落部分 */
  ::-webkit-scrollbar-corner {
    background-color: #f1f1f1;
  }
:deep(.ant-modal-body) {
    height:100vh!important;
    max-height: 100vh!important;
     }
</style>
